import React, { useState, useEffect } from 'react';
import { Tag, Select, Button, message } from 'antd';

import {callApi} from '../../helpers/Api';
const { Option } = Select;

const StoryTags = (props) => {
    const [admin, setAdmin] = useState(false);
    const [myCategories, setMyCategories] = useState([]);
    const [allCategories, setAllCategories] = useState([]);
    const [categoryInput, setInputCategory] = useState([]);
    const [inputVisible, setInputVisible] = useState(false);

    useEffect(() => {
        if (props.admin) {
            setAdmin(true);
        }

        callApi('/api/story_category/all')
            .then(json => {
                setAllCategories(json);
        })

        callApi('/api/story_category_aff/storytags/' + props.storyId)
        .then(json => {
            setMyCategories(json);
        })
    }, [props.storyId, props.admin])

    const showInput = () => {
        setInputVisible(true);
        setInputCategory(myCategories.map(tag => allCategories.find(x => {
            return tag.story_category_id === x.id
        }).name));
    };

    const handleChange = (values) => {
        if(values.length <= 3) {
            setInputCategory(values)
        } else {
            setInputVisible(false);
            message.error('Too many categories selected');
        }
    }

    const handleClose = removedTag => {
        if(admin) {
            const tags = myCategories.filter(tag => tag !== removedTag);
            callApi('/api/story_category_aff/' + removedTag.id, {
                method: 'DELETE',
            })
            .then(() => {
                setMyCategories(tags);
            })
        }
      };

    const onSubmit = () => {
        var include = [];
        categoryInput.map((value, i) => {
            let storyCategoryId = allCategories.find(x => {
                return value === x.name
            }).id
            include.push({story_id: props.storyId, story_category_id: storyCategoryId})
            return true;
        })

        // Checks if current tags is equal to existing tags
        if(include.map(x => x.story_category_id).sort().toString() === 
        myCategories.map(x => x.story_category_id).sort().toString()) {
            setInputVisible(false);
            return;
        }

        callApi('/api/story_category_aff/story', {
            method: 'POST',
            body: JSON.stringify({include, storyId: props.storyId})
        })
        .then(json => {
            setMyCategories(json);
            setInputVisible(false);
        })
    }

    return (
        <div>
            {inputVisible && (
                <div>
                    <Select
                        mode="multiple"
                        style={{ width: '100%' }}
                        placeholder="Select up to 3 categories"
                        defaultValue={myCategories.map(tag => allCategories.find(x => {
                            return tag.story_category_id === x.id
                        }).name)}
                        onChange={handleChange}
                    >
                        {allCategories.map((category, i) =>
                            <Option key={category.name} idvalue={category.id}>{category.name}</Option>
                        )}
                    </Select>
                    <Button onClick={onSubmit}>Save</Button>
                </div>
            )}
            {!inputVisible && (
                <div>
                    {myCategories.map((tag, index) => {
                        return (
                            <Tag key={index} onClose={() => handleClose(tag)}>
                                {allCategories.find(x => {
                                    return tag.story_category_id === x.id
                                })?.name}
                            </Tag>
                        )
                    })}
                    {admin ? (
                    <Tag onClick={showInput} style={{ background: '#fff', borderStyle: 'dashed' }}>
                        edit categories
                    </Tag>
                    ) : null}
                </div>
            )}
        </div>
    )
}

export default StoryTags;